import { toValue } from 'vue'
// Exports

export function toDate(input, time = false) {
  var value = toValue(input)
  
  if (!value) return null

  return dayjs(value).toDate()
}

export function formatDate(input, time = false, format='MM/DD/YYYY') {
  var value = toValue(input)
  
  if (!value) return null

  if (time) {
    value = dayjs(value).format(`${format} HH:mm`)
  } else {
    value = dayjs(value).format(format)
  }
  
  return value
}

export function convertToNumber(input) {
  if (!input) return input
  if (typeof number == 'number') return input

  // Keep decimals/signs /[^0-9.-]/g 
  // Matches anything NOT a digit, period, or dash.
  let value
  value = toValue(input)
  value = value.replace(/[^0-9.-]/g, "")
  value = parseFloat(value)
  return Number(value)
}

export function formatCurrency(input, isRounded = true) {
  var value = toValue(input)
  
  if (typeof value !== "number") {
    value = convertToNumber(value) // parseFloat(value) //Number(value)
  }
  // console.log('formatCurrency', typeof input, input, typeof value, value)

  if (isRounded) {
    value = currencyFormatterRounded.format(Math.round(value));
  } else {
    value = currencyFormatterWithPennies.format(value);  
  }

  return value
}

export function formatNum(input, numDigits = 2) {
  var value = toValue(input)

  if (typeof value !== "number") {
      return value;
  }

  let options = {minimumFractionDigits: 1, maximumFractionDigits: numDigits}

  if(numDigits == 0){
    options = {minimumFractionDigits: 0, maximumFractionDigits: 0}
  }

  return new Intl.NumberFormat('en-US', options).format(value)
}

export function percent(input, numDigits = 2) {
  const value = toValue(input)
  if (value == null || isNaN(value)) return '—'
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: numDigits,
    maximumFractionDigits: numDigits,
  }).format(value) + '%'
}

export function formatDateRange(sDate, eDate, formatString='MMM DD, YYYY') {
  const startDate = dayjs(sDate).format(formatString)
  const endDate = dayjs(eDate).format(formatString)
  const dateStr = `${startDate} - ${endDate}`
  return dateStr
}

export function formatDateToNow(input) {
  return input ? dayjs().to(dayjs(input)) : '-' // ex: 3 days ago
}

// Private helpers

const currencyFormatterRounded = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0, // don't show pennies
})

const currencyFormatterWithPennies = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2, // show pennies
})

// const dateFormats = {
//   shortDate: 'MM/DD/YY',
//   shortDateTime: 'MM/DD/YY HH:mm',
// }

// --------------------------------------------
// Below I'm making common helper methods available on a new format
// object to be used in components and views. This is the new way
// I'd like to use formatting functions (Kamal, 01.12.2025)
// --------------------------------------------
import utils from "@/utils/utils"
export const format = {
  camelCase: utils.camelCase,
  capitalize: utils.capitalize,
  startCase: utils.startCase,
  date: formatDate,
  currency: formatCurrency,
  number: formatNum,
  percent,
  dateToNow: formatDateToNow,
  toDate,
}
